import styled from 'styled-components';

import { ArticleSection } from 'editorial/components/ArticleSection';
import { ArticleImage } from 'editorial/components/ArticleImage';
import { IArticleFullImageSection, IArticleSectionAdditionalProps } from 'editorial/types';

export const ArticleFullImage = ({
  pictures,
  caption,
  credits,
}: IArticleFullImageSection & IArticleSectionAdditionalProps) => {
  return (
    <ArticleSection hasImage>
      <ArticleFullImage.Wrapper>
        <ArticleImage caption={caption} credits={credits} picture={pictures[0]} sizes="90vw" />
      </ArticleFullImage.Wrapper>
    </ArticleSection>
  );
};

ArticleFullImage.Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 999999px;
`;
